import { Outlet, Navigate } from 'react-router-dom'

export default function PrivateRoutes ({auth}) {
    return auth ? <Outlet/> : <Navigate to="/"/>
}